import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-personal-ledger-in-detail',
  templateUrl: './personal-ledger-in-detail.component.html',
  styleUrl: './personal-ledger-in-detail.component.scss'
})
export class PersonalLedgerInDetailComponent {

  reportType: any
  startDate: any
  endDate: any
  repName: any
  offRepName: any
  advtName: any
  issueDates: any
  issueDates1: any
  currentDate: any

  cust_name: any
  getpersonalleddata: any;
  balancecfamt: any;

  constructor(
    private dialogRef: MatDialogRef<PersonalLedgerInDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
  ) {

    this.currentDate = new Date();
    debugger
    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['offRepName'];
    this.advtName = this.data['name'];
    this.issueDates = this.data.issueDates;
    this.issueDates1 = this.data['issue_date'];
    this.cust_name = this.data['cust_name'];




    const req1: any = {

      "start_date": this.startDate,
      "end_date": this.endDate,
      "advt_name": this.data['name']
    }
    // persoanl ledger
    this.service.getPersoanlLed(req1).subscribe((data: any) => {

      debugger
      console.log("Get ledgerdata", data)
      this.getpersonalleddata = data as any;
      this.balancecfamt = this.getpersonalleddata[0].opening_bal;

      debugger
      for (let data1 of this.getpersonalleddata[0].rep_data) {

        if (data1.net_amt !== null && data1.net_amt !== "") {
          this.balancecfamt = parseFloat(data1.net_amt) + parseFloat(this.balancecfamt);
          data1.act_amt = this.balancecfamt;
          // data1.act_amt = null;

          debugger
        } else if (data1.actual_arc_amt !== null && data1.actual_arc_amt !== "") {  // Added condition
          data1.act_amt = parseFloat(this.balancecfamt) - parseFloat(data1.actual_arc_amt);


          this.balancecfamt = data1.act_amt;

          debugger
        } else if (data1.credit_amt !== null && data1.credit_amt !== "") {
          data1.act_amt = parseFloat(this.balancecfamt) - parseFloat(data1.credit_amt);
          this.balancecfamt = data1.act_amt;
        }



      }

    });



  }



  show = false


//   printPageA4Landscape() {
//     this.show = true;
//     const printSection = document.getElementById('print-section');
//     if (!printSection) {
//       console.error("Print section not found!");
//       return;
//     }

//     const printContent = printSection.innerHTML;
//     const screenWidth = window.screen.availWidth;
//     const windowWidth = 1000;
//     const leftPosition = screenWidth - windowWidth - 50;

//     const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);

//     if (printWindow) {
//       printWindow.document.open();
//       printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             @media print {
//               @page {
//                 size: A4 landscape;
//                 margin: 5mm;
//               }

//               body {
//                 margin: 0;
//                 padding: 0;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }

//               /* Prevent duplicate headers */
//               thead {
//                 display: table-header-group;
//               }
//               tfoot {
//                 display: table-footer-group;
//               }

//               /* Table styles */
//               table {
//                 border-collapse: collapse;
//                 width: 100% !important;
//                 font-size: 12px;
//                 page-break-inside: auto;
//               }

//               th, td {
//                 border: 1px solid black !important;
//                 padding: 3px 5px !important;
//                 white-space: nowrap;
//                 text-align:end;
//               }

//               /* Ensure no page breaks inside rows */
//               tr {
//                 page-break-inside: avoid;
//                 page-break-after: auto;
//               }

//               /* Scale down if needed */
//               @page :footer {
//                 display: none;
//               }
//               @page :header {
//                 display: none;
//               }

//               table th:nth-child(4),
// table td:nth-child(4) {
//   border-right: 4px solid black !important;

// }


// th, td {
//     border: 1px solid black !important;
//     padding: 4px;
//   }

//   /* Force visible vertical borders even on colspan cells */
//   tr td[colspan] {
   
//     border-right: 1px solid black !important;
//   }

 

//   /* Special case for the thick divider between debit/credit columns */
//   td[style*="border-right: 4px solid black"] {
//     border-right: 4px solid black !important;
//   }

//   td, th {
//     vertical-align: middle;
//     text-align: center;
//   }
//               /* Hide non-print elements */
//               .noPrint {
//                 display: none !important;
//               }
//             }

//             @media screen {
//               body {
//                 background-color: #f1f1f1;
//                 margin: 0;
//                 padding: 20px;
//               }
              
//               .print-section {
//                 background: white;
//                 box-shadow: 0 0 5px rgba(0,0,0,0.1);
//                 padding: 20px;
                
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-section">${printContent}</div>
//           <script>
//             window.onload = function() {
//               setTimeout(function() {
//                 window.print();
//                 setTimeout(function() {
//                   window.close();
//                 }, 500);
//               }, 200);
//             };
//           </script>
//         </body>
//       </html>
//     `);

//       printWindow.document.close();
//     } else {
//       console.error("Failed to open print window.");
//     }
//   }


// printPageA4Landscape() {
//     this.show = true;
//     const printSection = document.getElementById('print-section');
//     if (!printSection) {
//       console.error("Print section not found!");
//       return;
//     }

//     const printContent = printSection.innerHTML;
//     const screenWidth = window.screen.availWidth;
//     const windowWidth = 1000;
//     const leftPosition = screenWidth - windowWidth - 50;

//     const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);

//     if (printWindow) {
//       printWindow.document.open();
//       printWindow.document.write(`
//       <html>
//         <head>
//           <title>Print Report</title>
//           <style>
//             @media print {
//               @page {
//                 size: A4 landscape;
//                 margin: 5mm;
//               }

//               body {
//                 margin: 0;
//                 padding: 0;
//                 -webkit-print-color-adjust: exact;
//                 print-color-adjust: exact;
//               }

//               thead {
//                 display: table-header-group;
//               }
//               tfoot {
//                 display: table-footer-group;
//               }

//               table {
//                 border-collapse: collapse;
//                 width: 100% !important;
//                 font-size: 12px;
//                 page-break-inside: auto;
//                 border: 1px solid black;
//               }

//               th, td {
//                 border: 1px solid black;
//                 padding: 3px 5px;
//                 white-space: nowrap;
//                 vertical-align: middle;
//               }

//               tr {
//                 page-break-inside: avoid;
//                 page-break-after: auto;
//               }

//               @page :footer {
//                 display: none;
//               }
//               @page :header {
//                 display: none;
//               }

//               /* Preserve inline styles for thick borders */
//               th[style*="border-right: 4px solid black"],
//               td[style*="border-right: 4px solid black"] {
//                 border-right: 4px solid black !important;
//               }

//               /* Also target by position for header row */
//               thead tr:nth-child(2) th:first-child {
//                 border-right: 4px solid black !important;
//               }

//               thead tr:nth-child(3) th:nth-child(4) {
//                 border-right: 4px solid black !important;
//               }

//               /* For data rows - 4th column */
//               tbody tr td:nth-child(4):not([colspan]) {
//                 border-right: 4px solid black !important;
//               }

//               .text-right {
//                 text-align: right !important;
//               }

//               .text-left {
//                 text-align: left !important;
//               }

//               .no-wrap {
//                 white-space: nowrap;
//               }

//               .noPrint {
//                 display: none !important;
//               }
//             }

//             @media screen {
//               body {
//                 background-color: #f1f1f1;
//                 margin: 0;
//                 padding: 20px;
//               }
              
//               .print-section {
//                 background: white;
//                 box-shadow: 0 0 5px rgba(0,0,0,0.1);
//                 padding: 20px;
//               }
//             }
//           </style>
//         </head>
//         <body>
//           <div class="print-section">${printContent}</div>
//           <script>
//             window.onload = function() {
//               setTimeout(function() {
//                 window.print();
//                 setTimeout(function() {
//                   window.close();
//                 }, 500);
//               }, 200);
//             };
//           </script>
//         </body>
//       </html>
//     `);

//       printWindow.document.close();
//     } else {
//       console.error("Failed to open print window.");
//     }
//   }

printPageA4Landscape() {
    this.show = true;
    const printSection = document.getElementById('print-section');
    if (!printSection) {
      console.error("Print section not found!");
      return;
    }
    const printContent = printSection.innerHTML;
    const screenWidth = window.screen.availWidth;
    const windowWidth = 1000;
    const leftPosition = screenWidth - windowWidth - 50;
    const printWindow = window.open('', '', `width=${windowWidth},height=800,top=50,left=${leftPosition},scrollbars=yes`);
    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
      <html>
        <head>
          <title>Print Report</title>
          <style>
            @media print {
              @page {
                size: A4 landscape;
                margin: 5mm;
              }
              body {
                margin: 0;
                padding: 0;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              thead {
                display: table-header-group;
              }
              tfoot {
                display: table-footer-group;
              }
              table {
                border-collapse: collapse;
                width: 100% !important;
                font-size: 12px;
                page-break-inside: auto;
                border: 1px solid black;
              }
              th, td {
                border: 1px solid black;
                padding: 3px 5px;
                white-space: nowrap;
                vertical-align: middle;
              }
              tr {
                page-break-inside: avoid;
                page-break-after: auto;
              }
              @page :footer {
                display: none;
              }
              @page :header {
                display: none;
              }
              /* Dark bottom border for advt_name and header rows */
               tr {
                border-bottom: 2px solid black !important;
              }
              /* Preserve inline styles for thick borders */
              th[style*="border-right: 4px solid black"],
              td[style*="border-right: 4px solid black"] {
                border-right: 4px solid black !important;
              }
              /* Also target by position for header row */
              thead tr:nth-child(2) th:first-child {
                border-right: 4px solid black !important;
              }
              thead tr:nth-child(3) th:nth-child(4) {
                border-right: 4px solid black !important;
              }
              /* For data rows - 4th column */
              tbody tr td:nth-child(4):not([colspan]) {
                border-right: 4px solid black !important;
              }
              .text-right {
                text-align: right !important;
              }
              .text-left {
                text-align: left !important;
              }
              .no-wrap {
                white-space: nowrap;
              }
              .noPrint {
                display: none !important;
              }
            }
            @media screen {
              body {
                background-color: #f1f1f1;
                margin: 0;
                padding: 20px;
              }
              
              .print-section {
                background: white;
                box-shadow: 0 0 5px rgba(0,0,0,0.1);
                padding: 20px;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-section">${printContent}</div>
          <script>
            window.onload = function() {
              setTimeout(function() {
                window.print();
                setTimeout(function() {
                  window.close();
                }, 500);
              }, 200);
            };
          </script>
        </body>
      </html>
    `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}

